import { render, staticRenderFns } from "./CalendarItem.vue?vue&type=template&id=722ea913&scoped=true"
import script from "./CalendarItem.vue?vue&type=script&lang=js"
export * from "./CalendarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722ea913",
  null
  
)

export default component.exports